import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA Service Worker with aggressive auto-update on every deployment
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        updateViaCache: 'none'  // Always fetch fresh SW from network
      });
      console.log('[PWA] Service worker registered');

      // Check for updates immediately
      registration.update().catch(() => {});

      // Check for updates every 30 seconds (catches deployments quickly)
      setInterval(() => {
        registration.update().catch(() => {});
      }, 30 * 1000);

      // When a new SW is found, auto-activate it
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW installed while old one was active — tell it to take over
              console.log('[PWA] New version available, activating...');
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
    } catch (error) {
      console.log('[PWA] Service worker registration failed:', error);
    }
  });

  // When the new SW takes control, reload for fresh content
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      console.log('[PWA] New version activated, refreshing...');
      window.location.reload();
    }
  });

  // Listen for SW_UPDATED message (backup refresh trigger)
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      console.log('[PWA] Received update notification:', event.data.version);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
